import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import Spinner from '../spinner'
import { ButtonContained, ButtonOutlined } from '../app-button/button'
import { required } from './validation/validation'
import renderSelectField from './field/customSelect'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'
import { DeliteIcon } from '../app-icon/Icons'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import FormControl from '@material-ui/core/FormControl'
import RadioGroup from '@material-ui/core/RadioGroup'

const styles = theme => ({
  form: {
    maxWidth: 340,
    width: '100%',
  },
  chip: {
    width: '100%',
    marginBottom: 16,
  },
  root: {
    paddingLeft: 21,
    paddingRight: 3,
    borderRadius: 4,
    height: 48,
    justifyContent: 'flex-start',
  },
  colorSecondary: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  deleteIcon: {
    color: '#000',
    marginLeft: 'auto',
    '&:hover': {
      color: '#000',
    },
  },
  label: {
    paddingLeft: 0,
  },
  fieldGroupe: {
    display: 'flex',
  },
  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  '@keyframes wiggle2': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
})

const campaignsFilterModeOffRadio = ({ input, ...rest }) => (
  <FormControl>
    <RadioGroup {...input} {...rest}>
      <FormControlLabel value="off" control={<Radio />} label="Все кампании" />
    </RadioGroup>
  </FormControl>
)

const campaignsFilterModeOnRadio = ({ input, ...rest }) => (
  <FormControl>
    <RadioGroup {...input} {...rest}>
      <FormControlLabel
        value="on"
        control={<Radio />}
        label="Выбрать кампании"
      />
    </RadioGroup>
  </FormControl>
)

class FacebookChannelForm extends Component {
  state = {
    selectedAccount: null,
    selectedCustomer: null,
    campaignsFilterMode: 'off',
  }

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  // переключение радио баттоннов
  handleChangeCampaignsFilter = event => {
    this.setState({ campaignsFilterMode: event.target.value })
  }

  handleDelete = () => {
    location.href = this.props.dataSource.deleteUrl // eslint-disable-line no-alert
  }

  handleAccountChange = event => {
    this.setState({ selectedAccount: event.target.value })
  }

  handleChange = event => {
    this.setState({ selectedCustomer: event.target.value })
    this.props.loadCampaigns(event.target.value)
  }

  redirect = (url, status) => {
    if (status === 'ok') {
      location.href = url
    }
  }

  getAccountList = () => {
    const list = this.props.dataSource.customers.map(account => {
      return account
    })
    return list
  }

  getCustomerList = selectedAccount => {
    const { dataSource } = this.props
    let customer = null

    selectedAccount = selectedAccount || this.state.selectedAccount || null

    if (dataSource.accountId) {
      let key = -1
      for (key in dataSource.customers) {
        if (dataSource.customers[key]['id'] == dataSource.accountId) {
          break
        }
      }

      if (key >= 0) {
        customer = dataSource.customers[key]['id']
      }
    }

    if (selectedAccount || customer) {
      let accountId = selectedAccount || customer
      for (var key in dataSource.customers) {
        if (dataSource.customers[key]['id'] == accountId) {
          break
        }
      }

      if (dataSource.customers[key] && dataSource.customers[key]['customers']) {
        let list = dataSource.customers[key]['customers'].map(customer => {
          return customer
        })

        return list
      }
    } else if (!this.getAccountList().length) {
      const list = dataSource.customers.map(customer => {
        return customer
      })

      return list
    }

    return []
  }

  componentDidMount = () => {
    this.setState({
      campaignsFilterMode: this.props.initialValues.campaigns_filter_mode,
    })
  }

  render() {
    const {
      classes,
      handleSubmit,
      isFetching,
      submitFailed,
      invalid,
      dataSource,
    } = this.props

    const profiles = () => {
      if (!dataSource) {
        return
      }

      const list = dataSource.profiles.map(account => {
        return (
          <MenuItem value={account.id} key={account.id}>
            {account.name}
          </MenuItem>
        )
      })

      return list
    }

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <Chip
          label={dataSource.accountName}
          onDelete={dataSource.status === 'inactive' ? this.handleDelete : null}
          className={classes.chip}
          variant="outlined"
          color="secondary"
          classes={{
            root: classes.root,
            label: classes.label,
            colorSecondary: classes.colorSecondary,
            deleteIconOutlinedColorSecondary: classes.deleteIcon,
          }}
        />

        {!dataSource.hasAuthError ? (
          <div>
            <Field
              name="profile"
              onChange={this.handleChange}
              // value={this.state.selectedAccount}
              component={renderSelectField}
              validate={[required]}
            >
              <MenuItem value="" style={{ display: 'none' }}>
                <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                  Выберите профиль
                </span>
              </MenuItem>
              {profiles()}
            </Field>

            <div>
              <Field
                name="campaigns_filter_mode"
                component={campaignsFilterModeOffRadio}
                onChange={this.handleChangeCampaignsFilter}
              >
                <Radio value="off" label="off" />
              </Field>
              <Typography
                variant="subtitle1"
                component="div"
                style={{
                  marginBottom: 8,
                }}
              >
                Получать расходы по всем кампаниям на аккаунте
              </Typography>

              <Field
                name="campaigns_filter_mode"
                component={campaignsFilterModeOnRadio}
                onChange={this.handleChangeCampaignsFilter}
              >
                <Radio value="on" label="on" />
              </Field>
              <div style={{ position: 'relative' }}>
                {this.state.campaignsFilterMode === 'off' ? (
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: '#fff',
                      opacity: 0.6,
                      zIndex: 2,
                    }}
                  />
                ) : null}
                <Typography
                  variant="subtitle1"
                  style={{
                    marginBottom: 8,
                  }}
                >
                  Получать расходы только по выбранным кампаниям
                </Typography>
                {this.props.campaigns ? (
                  <div
                    style={{
                      marginBottom: 32,
                      maxHeight: 265,
                      overflowY: 'auto',
                    }}
                  >
                    {this.props.campaigns.map((campaign, index) => {
                      return (
                        <FormControlLabel
                          key={campaign.id}
                          control={
                            <Checkbox
                              checked={
                                this.props.checkedCampaigns.indexOf(
                                  campaign.id
                                ) > -1
                              }
                              onChange={this.props.handleCampaignChange(
                                campaign.id
                              )}
                              value={`${campaign.id}`}
                            />
                          }
                          label={`${campaign.name} (ID: ${campaign.id})`}
                        />
                      )
                    })}
                  </div>
                ) : (
                  <div style={{ marginBottom: 32 }}>Нет доступных кампаний</div>
                )}
              </div>
            </div>

            <Typography
              variant="subtitle1"
              component="div"
              style={{
                marginBottom: 8,
                padding: '6px 13px 6px',
                backgroundColor: 'rgba(255, 204, 0, .2)',
              }}
            >
              <strong>Обратите внимание: </strong>
              данные о расходах из этого канала передаются с уже включённым НДС
            </Typography>

            <Typography
              variant="subtitle1"
              component="div"
              style={{
                marginBottom: 8,
                padding: '6px 13px 6px',
                backgroundColor: 'rgba(255, 204, 0, .2)',
              }}
            >
              Обратите пожалуйста внимание, что валюта платежного аккаунта
              площадки должна быть рубли.
            </Typography>

            <Typography
              variant="subtitle1"
              component="div"
              style={{
                marginBottom: 8,
                padding: '6px 13px 6px',
                backgroundColor: 'rgba(255, 204, 0, .2)',
              }}
            >
              После подключения рекламного канала Facebook, ROMI center
              импортирует расходы в том числе из Instagram, если аккаунт
              Instagram подключен к рекламному кабинету Facebook Ads Manager.
            </Typography>
          </div>
        ) : null}
        <Typography
          variant="subtitle1"
          component="div"
          style={{
            marginBottom: 8,
            padding: '6px 13px 6px',
            backgroundColor: 'rgba(255, 204, 0, .2)',
          }}
        >
          При добавлении новых рекламных кампаний внутри рекламного кабинета,
          они автоматически станут доступными для выбора здесь.
        </Typography>
        {dataSource.hasAuthError == 1 ? (
          <Typography
            variant="subtitle1"
            component="div"
            style={{
              marginBottom: 8,
              padding: '6px 13px 6px',
              backgroundColor: 'rgba(255, 59, 48, 0.1)',
            }}
          >
            Ошибка авторизации. Для корректной работы необходимо удалить канал и
            подключить его заново.
          </Typography>
        ) : null}

        {dataSource.status === 'active' ? (
          <div style={{ marginTop: 16, display: 'flex' }}>
            {!dataSource.hasAuthError ? (
              <ButtonContained
                style={{
                  flexShrink: 0,
                  fontSize: 16,
                  width: 139,
                  height: 48,
                  padding: 0,
                  marginRight: 16,
                  fontWeight: 700,
                  color: '#fff',
                }}
                type="submit"
                color="secondary"
                text={isFetching ? <Spinner /> : 'Сохранить'}
                onClick={() => this.handleClick(classes, submitFailed)}
              />
            ) : null}

            <ButtonOutlined
              handleClick={this.handleDelete}
              style={{
                maxWidth: !dataSource.hasAuthError ? 280 : '100%',
                height: 48,
                width: '100%',
                padding: 0,
              }}
              color="secondary"
              text={'Удалить канал'}
            />
          </div>
        ) : (
          <ButtonContained
            style={{
              height: 48,
              fontSize: 16,
              width: '100%',
              padding: 0,
              fontWeight: 700,
              color: '#fff',
            }}
            type="submit"
            color="secondary"
            text={isFetching ? <Spinner /> : 'Добавить канал'}
            onClick={() => this.handleClick(classes, submitFailed)}
          />
        )}
      </form>
    )
  }
}

FacebookChannelForm = reduxForm({
  form: 'FacebookChannelForm',
})(FacebookChannelForm)

export default withStyles(styles)(FacebookChannelForm)
